export default "__VITE_ASSET__BIIRoTdc__"